module.exports = __webpack_public_path__ + "static/img/p1_1.d66da1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/product/p1_1.png
// module id = aOr0
// module chunks = 1